import React, {useState} from "react"

import Overlay from "./Overlay"

import "./Help.scss" 

function Help({title, children}) {
  const [isOpen, setIsOpen] = useState(false)

  let overlay = null 
  if(isOpen) {
    overlay = (
      <Overlay
        position="center"
        visible={isOpen}
        close={() => setIsOpen(false)}
      >
        <div className="c-help-overlay">
          <div className="c-help-overlay-heading">
            <div className="title">
              {title}
            </div>
            <div className="close" onClick={() => setIsOpen(false)}>
              <span>✕</span>
            </div>
          </div>
          <div className="c-help-overlay-content">
            {children}
          </div>
        </div>
      </Overlay>
    )
  }
  return (
    <>
      <div className="c-help-button" onClick={() => setIsOpen(!isOpen)}>
        <span>?</span>
      </div>
      {overlay}
    </>
  )
}

export default Help